export default __webpack_public_path__ + "static/media/profile-edite.8391b9c1.svg";